import { useMemo } from "react";
import { CompetitorWrapper } from "./CompetitorWrapper";
import { CompetitorName } from "./CompetitorName";
import { ScoreWithPossesion } from "./ScoreWithPossesion";
import { CompetitorDescription } from "./CompetitorDescription";
import { normalizeSport } from "shared/src/utils/sportMap";
import cx from "components/src/utils/cx";
import { TeamLogo } from "components-sbk/src/components/TeamLogo/TeamLogo";

export const CompetitorHorizontal = ({
  wrapperProps,
  showComputedIcon,
  showPlaceholder,
  activeIcon,
  _iconSize,
  inverse,
  readableToken,
  hasForceReadability,
  competitorNameProps,
  scoreWithPossesionProps,
  description,
  variant,
  center,
  compact,
  hasContainerQueries,
  inline,
  sport: _sportRaw,
  competitionType,
  hideScore,
  hasScorePadding,
  hideScorePadding,
  scoreStacked,
  setCompetitorRef,
  ...rest
}) => {
  const sport = normalizeSport(_sportRaw);
  const { hasScore } = scoreWithPossesionProps;
  const computedClasses = useMemo(() => {
    if (inline) {
      return cx(
        {
          "cui-flex-row-reverse": inverse,
          "cui-justify-end": scoreStacked,
        },
        "cui-inline-flex cui-items-center"
      );
    }
    return cx({
      "cui-@container": hasContainerQueries,
      "cui-flex-row cui-w-full cui-items-center": !center,
      "cui-justify-end": scoreStacked && !center && !inverse,
      "cui-justify-start": scoreStacked && !center && inverse,
      "cui-w-full cui-justify-center cui-items-center": center,
      "cui-flex cui-flex-row-reverse": inverse,
      "cui-flex": !inverse,
    });
  }, [hasContainerQueries, inverse, center, inline]);
  const showPadding = (hasScore || hasScorePadding) && !hideScorePadding;
  const _showPlaceholder = showPlaceholder && sport === "football";

  const _hasIcon = (showComputedIcon && Boolean(activeIcon)) || showPlaceholder;

  return (
    <CompetitorWrapper {...wrapperProps}>
      <div
        className={cx(
          {
            "cui-justify-center": center,
            "cui-justify-end": inverse,
          },
          "cui-w-full cui-flex cui-flex-grow cui-items-center cui-relative"
        )}
        ref={setCompetitorRef}
      >
        <div className={computedClasses}>
          {showComputedIcon ? (
            <div
              className={cx(
                {
                  "cui-mr-xs": !inverse && !scoreStacked,
                  "cui-ml-xs": inverse && !scoreStacked,
                  "-cui-ml-xs": inverse && scoreStacked,
                  "-cui-mr-xs": !inverse && scoreStacked,
                  // "cui-min-w-[36px]": !compact
                },
                "cui-flex"
              )}
            >
              {activeIcon}
            </div>
          ) : null}
          {!showComputedIcon && _showPlaceholder ? (
            <div className="cui-mr-xs cui-min-w-9 cui-min-h-9">
              <TeamLogo size={_iconSize ?? 36} name="" sport={sport} competitionType={competitionType} isPlaceholder />
            </div>
          ) : null}
          {!scoreStacked ? (
            <div
              className={cx(
                {
                  [readableToken as string]: hasForceReadability,
                  "cui-text-fg-default": !hasForceReadability,
                  "cui-pl-sm": inverse && showPadding,
                  "cui-pr-sm": !inverse && showPadding,
                },
                "cui-flex cui-flex-col"
              )}
            >
              <CompetitorName
                {...competitorNameProps}
                forcedReadableToken={readableToken}
                hasIcon={_hasIcon}
                hasScore={hasScore && !hideScore}
              />
              <CompetitorDescription
                description={description}
                inverse={inverse}
                variant={variant}
                forcedReadableToken={readableToken}
                {...rest}
              />
            </div>
          ) : null}
          {compact && hasScore && !hideScore ? (
            <div
              className={cx({
                "cui-flex-col": scoreStacked,
              })}
            >
              {scoreStacked ? (
                <CompetitorName
                  {...competitorNameProps}
                  forceReadableToke={readableToken}
                  textSize="display-sm"
                  hasIcon={_hasIcon}
                  hasScore={hasScore && !hideScore}
                />
              ) : null}
              <ScoreWithPossesion
                {...scoreWithPossesionProps}
                forcedReadableToken={readableToken}
              />
            </div>
          ) : null}
        </div>
      </div>
      {!compact && hasScore && !hideScore ? (
        <ScoreWithPossesion
          {...scoreWithPossesionProps}
          forcedReadableToken={readableToken}
        />
      ) : null}
    </CompetitorWrapper>
  );
};
